/**
 * Baacal — signup custom trigger (Xk4zw5) + cart-exit Save Cart (WFESXS)
 *
 * Why (CR / list growth):
 *  - ShopifyQL (Baacal): 30d avg session ~20s; only ~4.4% sessions >45s; ~92% ≤8s.
 *    90d: avg ~25s; ~6.1% >45s; ~89% ≤8s. A 45s-only interrupt misses ~95% of sessions.
 *  - Theme owns timing via openForm (custom trigger) so Klaviyo delay isn't dual-firing.
 *  - Teaser @15s = primary capture in the avg-session band (tiny, non-blocking; click → full).
 *  - Full flyout @45s = engaged-tail backup (~5% of sessions) + empty-cart exit-intent.
 *  - Cart ≥1 → never open signup; exit → Save Cart instead (no dual interrupt).
 *  - Identified profiles must NOT see interruptive signup, but CAN still get Save Cart on exit.
 *
 * How:
 *  1) Empty cart + not identified + desktop:
 *       - 15s: show theme teaser (click → openForm Xk4zw5)
 *       - 45s: openForm full flyout (engaged tail)
 *       - exit intent: openForm full flyout (short sessions that bounce)
 *  2) Cart ≥1 + exit: openForm('WFESXS'); allow identified; track Saved Cart on submit
 *  3) Mutual session exclude signup↔save; skip /cart /checkout / drawer open
 *
 * Klaviyo has no documented openTeaser API — openForm opens the full form only.
 * Form Xk4zw5 may define a native teaser, but custom-trigger timing cannot split
 * teaser @15s vs full @45s; theme owns the early teaser (approach B).
 *
 * Identified gate: klaviyo.isIdentified() (developers.klaviyo.com).
 * Requires both forms published with Display = Only show on custom trigger.
 * Docs: https://help.klaviyo.com/hc/en-us/articles/4418052317339
 *       https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object
 */
(function () {
  var SAVE_FORM_ID = 'WFESXS';
  var SIGNUP_FORM_ID = 'Xk4zw5';
  var SAVE_COOKIE = 'baacal_cart_exit_form_WFESXS';
  var SIGNUP_COOKIE = 'baacal_signup_flyout_Xk4zw5';
  var SESSION_SAVE = 'baacal_save_cart_shown';
  var SESSION_SIGNUP = 'baacal_signup_flyout_shown';
  var SESSION_TEASER_DISMISS = 'baacal_signup_teaser_dismissed';
  var COOKIE_DAYS = 14;
  var TEASER_DELAY_MS = 15000; // primary — fits ~20s avg session band (Amy 15–20; data-tuned)
  var SIGNUP_DELAY_MS = 45000; // engaged-tail backup (~5% of sessions >45s)
  var MIN_MS_ON_PAGE = 2500;
  var MIN_MS_MOBILE_LEAVE = 8000;
  var TEASER_ID = 'baacal-signup-teaser-Xk4zw5';

  var saveShown = false;
  var signupShown = false;
  var teaserShown = false;
  var teaserDismissed = false;
  var cartItemCount = 0;
  var lastCart = null;
  var pageReadyAt = Date.now();
  var savedCartTracked = false;
  var signupTimer = null;
  var teaserTimer = null;
  var klaviyoIdentified = false;

  function getCookie(name) {
    var match = document.cookie.match(
      new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
    );
    return match ? decodeURIComponent(match[1]) : '';
  }

  function setCookie(name, value, days) {
    var maxAge = days * 24 * 60 * 60;
    var secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      maxAge +
      '; SameSite=Lax' +
      secure;
  }

  function sessionGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function sessionSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      /* ignore */
    }
  }

  function pathBlocked() {
    var path = (location.pathname || '').toLowerCase();
    if (path.indexOf('/checkout') !== -1) return true;
    if (path === '/cart' || path.indexOf('/cart/') === 0) return true;
    if (path.indexOf('/signup') !== -1 || path.indexOf('/sign-up') !== -1) return true;
    return false;
  }

  function cartDrawerOpen() {
    return !!(document.body && document.body.classList.contains('js-drawer-open-cart'));
  }

  function isDesktop() {
    // Align with Amy's Klaviyo "Desktop only" for Xk4zw5
    try {
      return !(window.matchMedia && window.matchMedia('(max-width: 768px)').matches);
    } catch (e) {
      return true;
    }
  }

  function cartUrl() {
    var routes = (window.theme && window.theme.routes) || {};
    return routes.cart_url || '/cart';
  }

  /**
   * Documented onsite API: klaviyo.isIdentified([callback]) → boolean / Promise.
   * https://developers.klaviyo.com/en/docs/introduction_to_the_klaviyo_object
   * https://help.klaviyo.com/hc/en-us/articles/360034666712
   */
  function checkKlaviyoIdentified(done) {
    var settled = false;
    function finish(value) {
      if (settled) return;
      settled = true;
      done(!!value);
    }

    try {
      window.klaviyo = window.klaviyo || [];
      if (typeof window.klaviyo.isIdentified === 'function') {
        var result = window.klaviyo.isIdentified(function (identified) {
          finish(identified);
        });
        if (result && typeof result.then === 'function') {
          result.then(finish).catch(function () {
            finish(false);
          });
        }
        return;
      }
      if (typeof window.klaviyo.push === 'function') {
        window.klaviyo.push([
          'isIdentified',
          function (identified) {
            finish(identified);
          },
        ]);
        return;
      }
    } catch (e) {
      /* fall through */
    }
    finish(false);
  }

  function applyIdentifiedState(identified) {
    klaviyoIdentified = !!identified;
    if (klaviyoIdentified) {
      document.documentElement.setAttribute('data-baacal-klaviyo-identified', '1');
      cancelSignupTimer();
      cancelTeaserTimer();
      hideThemeTeaser();
      hideSignupFlyout();
    } else {
      document.documentElement.removeAttribute('data-baacal-klaviyo-identified');
    }
  }

  function refreshIdentified(done) {
    checkKlaviyoIdentified(function (identified) {
      applyIdentifiedState(identified);
      if (typeof done === 'function') done(identified);
    });
  }

  function markSignupShown() {
    signupShown = true;
    setCookie(SIGNUP_COOKIE, '1', COOKIE_DAYS);
    sessionSet(SIGNUP_COOKIE, '1');
    sessionSet(SESSION_SIGNUP, '1');
    hideThemeTeaser();
    cancelTeaserTimer();
  }

  function markSaveShown() {
    saveShown = true;
    setCookie(SAVE_COOKIE, '1', COOKIE_DAYS);
    sessionSet(SAVE_COOKIE, '1');
    sessionSet(SESSION_SAVE, '1');
    hideThemeTeaser();
    cancelTeaserTimer();
    cancelSignupTimer();
  }

  function signupSuppressed() {
    if (getCookie(SIGNUP_COOKIE) || sessionGet(SIGNUP_COOKIE) === '1') return true;
    if (sessionGet(SESSION_SIGNUP) === '1') return true;
    if (sessionGet(SESSION_SAVE) === '1') return true; // save-cart already this session
    if (getCookie(SAVE_COOKIE)) return true;
    return false;
  }

  function saveSuppressed() {
    if (getCookie(SAVE_COOKIE) || sessionGet(SAVE_COOKIE) === '1') return true;
    if (sessionGet(SESSION_SAVE) === '1') return true;
    if (sessionGet(SESSION_SIGNUP) === '1') return true; // signup already this session
    return false;
  }

  function hideElAndFixedParents(el) {
    if (!el) return;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    var node = el.parentElement;
    for (var i = 0; i < 6 && node && node !== document.body; i++) {
      var pos = window.getComputedStyle(node).position;
      var z = parseInt(window.getComputedStyle(node).zIndex, 10) || 0;
      if (pos === 'fixed' && z >= 1000) {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      }
      node = node.parentElement;
    }
  }

  function hideSignupFlyout() {
    if (cartItemCount < 1 && !klaviyoIdentified) return;
    var selectors = [
      '[data-testid="klaviyo-form-' + SIGNUP_FORM_ID + '"]',
      '.kl-teaser-' + SIGNUP_FORM_ID,
      '.klaviyo-form-' + SIGNUP_FORM_ID,
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(hideElAndFixedParents);
    });
  }

  function cancelSignupTimer() {
    if (signupTimer) {
      clearTimeout(signupTimer);
      signupTimer = null;
    }
  }

  function cancelTeaserTimer() {
    if (teaserTimer) {
      clearTimeout(teaserTimer);
      teaserTimer = null;
    }
  }

  function canOpenSignup() {
    if (signupShown || signupSuppressed()) return false;
    if (pathBlocked() || cartDrawerOpen()) return false;
    if (cartItemCount >= 1) return false;
    if (klaviyoIdentified) return false; // known profile / cart email — no interruptive signup
    if (!isDesktop()) return false;
    return true;
  }

  function canShowTeaser() {
    if (teaserShown || teaserDismissed) return false;
    if (sessionGet(SESSION_TEASER_DISMISS) === '1') return false;
    if (!canOpenSignup()) return false;
    return true;
  }

  function ensureTeaserStyles() {
    if (document.getElementById('baacal-signup-teaser-styles')) return;
    var style = document.createElement('style');
    style.id = 'baacal-signup-teaser-styles';
    style.textContent =
      '#' +
      TEASER_ID +
      '{' +
      'position:fixed;bottom:20px;right:20px;z-index:2147483000;' +
      'display:flex;align-items:center;gap:8px;' +
      'padding:10px 14px;max-width:220px;' +
      'background:#fff;color:#000;border:1px solid rgba(0,0,0,0.12);' +
      'border-radius:4px;box-shadow:0 8px 24px rgba(0,0,0,0.12);' +
      'font:600 14px/1.2 Arial,Helvetica,sans-serif;letter-spacing:0.01em;' +
      'cursor:pointer;opacity:0;transform:translateY(8px);' +
      'transition:opacity .25s ease,transform .25s ease;' +
      '}' +
      '#' +
      TEASER_ID +
      '.is-visible{opacity:1;transform:translateY(0)}' +
      '#' +
      TEASER_ID +
      ' .baacal-signup-teaser__label{flex:1;text-align:left}' +
      '#' +
      TEASER_ID +
      ' .baacal-signup-teaser__close{' +
      'appearance:none;border:0;background:transparent;color:#666;' +
      'font:400 16px/1 Arial,Helvetica,sans-serif;cursor:pointer;' +
      'padding:2px 4px;margin:0;line-height:1' +
      '}' +
      'html[data-baacal-cart-has-items="1"] #' +
      TEASER_ID +
      ',' +
      'html[data-baacal-klaviyo-identified="1"] #' +
      TEASER_ID +
      ',' +
      'body.js-drawer-open-cart #' +
      TEASER_ID +
      ',' +
      'body.template-cart #' +
      TEASER_ID +
      '{display:none!important;pointer-events:none!important;visibility:hidden!important}';
    document.head.appendChild(style);
  }

  function hideThemeTeaser() {
    var el = document.getElementById(TEASER_ID);
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  function dismissThemeTeaser(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    teaserDismissed = true;
    sessionSet(SESSION_TEASER_DISMISS, '1');
    hideThemeTeaser();
    // Dismiss does NOT suppress 45s full flyout or empty-cart exit open
  }

  function onTeaserClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    hideThemeTeaser();
    openSignupForm();
  }

  function showThemeTeaser() {
    if (!canShowTeaser()) return;
    ensureTeaserStyles();
    hideThemeTeaser();

    var btn = document.createElement('button');
    btn.id = TEASER_ID;
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Get 15% Off — open signup');
    btn.innerHTML =
      '<span class="baacal-signup-teaser__label">Get 15% Off</span>' +
      '<span class="baacal-signup-teaser__close" aria-label="Dismiss" role="presentation">×</span>';

    btn.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('baacal-signup-teaser__close')) {
        dismissThemeTeaser(e);
        return;
      }
      onTeaserClick(e);
    });

    document.body.appendChild(btn);
    teaserShown = true;
    // next frame → visible transition
    requestAnimationFrame(function () {
      btn.classList.add('is-visible');
    });
  }

  function openSignupForm() {
    refreshIdentified(function () {
      if (!canOpenSignup()) return;
      signupShown = true;
      hideThemeTeaser();
      cancelTeaserTimer();
      cancelSignupTimer();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push([
        'openForm',
        SIGNUP_FORM_ID,
        function () {
          markSignupShown();
        },
      ]);
    });
  }

  function scheduleTeaser() {
    cancelTeaserTimer();
    if (!canShowTeaser()) return;
    teaserTimer = setTimeout(function () {
      teaserTimer = null;
      refreshCartCount(function () {
        refreshIdentified(function () {
          showThemeTeaser();
        });
      });
    }, TEASER_DELAY_MS);
  }

  function scheduleSignup() {
    cancelSignupTimer();
    if (!canOpenSignup()) return;
    signupTimer = setTimeout(function () {
      signupTimer = null;
      refreshCartCount(function () {
        openSignupForm();
      });
    }, SIGNUP_DELAY_MS);
  }

  function scheduleSignupCapture() {
    scheduleTeaser();
    scheduleSignup();
  }

  function buildSavedCartPayload(cart) {
    var origin = window.location.origin;
    var items = (cart.items || []).map(function (i) {
      return {
        product_id: i.product_id,
        variant_id: i.variant_id,
        title: i.product_title,
        variant_title: i.variant_title,
        price: (i.final_price != null ? i.final_price : i.price) / 100,
        quantity: i.quantity,
        image: i.image,
        url: origin + (i.url || ''),
        sku: i.sku || '',
      };
    });
    return {
      cart_token: cart.token,
      item_count: cart.item_count,
      total_price: (cart.total_price || 0) / 100,
      currency: cart.currency || '',
      cart_url: origin + cartUrl(),
      checkout_url: origin + '/checkout',
      items: items,
      $value: (cart.total_price || 0) / 100,
    };
  }

  function trackSavedCart(cart) {
    if (savedCartTracked) return;
    if (!cart || !cart.item_count) return;
    savedCartTracked = true;
    var payload = buildSavedCartPayload(cart);
    try {
      window.klaviyo = window.klaviyo || [];
      if (typeof window.klaviyo.track === 'function') {
        window.klaviyo.track('Saved Cart', payload);
      } else {
        window.klaviyo.push(['track', 'Saved Cart', payload]);
      }
    } catch (e) {
      /* ignore */
    }
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Saved Cart', payload]);
    } catch (e2) {
      /* ignore */
    }
  }

  function refreshCartCount(done) {
    fetch(cartUrl() + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        lastCart = cart;
        cartItemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
        if (cartItemCount >= 1) {
          document.documentElement.setAttribute('data-baacal-cart-has-items', '1');
          cancelSignupTimer();
          cancelTeaserTimer();
          hideThemeTeaser();
          hideSignupFlyout();
        } else {
          document.documentElement.removeAttribute('data-baacal-cart-has-items');
        }
        if (typeof done === 'function') done(cartItemCount);
      })
      .catch(function () {
        cartItemCount = 0;
        lastCart = null;
        document.documentElement.removeAttribute('data-baacal-cart-has-items');
        if (typeof done === 'function') done(0);
      });
  }

  // Save Cart: cart ≥1 + exit — allow identified/subscribed (do NOT gate on isIdentified)
  function canOpenSave() {
    if (saveShown || saveSuppressed()) return false;
    if (pathBlocked() || cartDrawerOpen()) return false;
    if (Date.now() - pageReadyAt < MIN_MS_ON_PAGE) return false;
    if (cartItemCount < 1) return false;
    return true;
  }

  function openSaveForm() {
    if (!canOpenSave()) return;
    saveShown = true;
    cancelSignupTimer();
    cancelTeaserTimer();
    hideThemeTeaser();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push([
      'openForm',
      SAVE_FORM_ID,
      function () {
        markSaveShown();
      },
    ]);
  }

  function isCoarsePointer() {
    try {
      return window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    } catch (e) {
      return 'ontouchstart' in window;
    }
  }

  function onExitIntent(e) {
    if (!e) return;
    if (typeof e.clientY === 'number' && e.clientY > 0) return;
    // Cart ≥1 → Save Cart; empty cart + unidentified → signup full (short-session capture)
    if (cartItemCount >= 1) {
      openSaveForm();
      return;
    }
    if (Date.now() - pageReadyAt < MIN_MS_ON_PAGE) return;
    openSignupForm();
  }

  function onVisibilityLeave() {
    if (document.visibilityState !== 'hidden') return;
    if (Date.now() - pageReadyAt < MIN_MS_MOBILE_LEAVE) return;
    var narrow = false;
    try {
      narrow = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    } catch (e) {
      /* ignore */
    }
    if (!isCoarsePointer() && !narrow) return;
    if (cartItemCount >= 1) {
      openSaveForm();
      return;
    }
    // Mobile leave with empty cart: signup is desktop-only — skip
  }

  function onCartChange() {
    refreshCartCount(function (n) {
      refreshIdentified(function () {
        if (n < 1 && !klaviyoIdentified && !signupShown && !signupSuppressed()) {
          scheduleSignupCapture();
        }
      });
    });
  }

  function onKlaviyoFormSubmit(e) {
    var detail = (e && e.detail) || {};
    var formId = detail.formId || detail.formID || detail.id || '';
    var meta = detail.metaData || detail.formMeta || {};
    if (!formId && meta.formId) formId = meta.formId;

    if (!formId && e && e.target) {
      var testId = e.target.getAttribute && e.target.getAttribute('data-testid');
      if (testId && testId.indexOf('klaviyo-form-') === 0) {
        formId = testId.replace('klaviyo-form-', '');
      }
    }

    if (formId === SIGNUP_FORM_ID || String(formId).indexOf(SIGNUP_FORM_ID) !== -1) {
      markSignupShown();
      return;
    }

    if (formId === SAVE_FORM_ID || String(formId).indexOf(SAVE_FORM_ID) !== -1) {
      markSaveShown();
      if (lastCart && lastCart.item_count >= 1) {
        trackSavedCart(lastCart);
      } else {
        refreshCartCount(function () {
          if (lastCart) trackSavedCart(lastCart);
        });
      }
    }
  }

  function bindKlaviyoSubmitListeners() {
    document.addEventListener('klaviyoForms', function (e) {
      var detail = (e && e.detail) || {};
      var type = detail.type || '';
      if (type === 'submit' || type === 'submitted' || type === 'form_submitted') {
        onKlaviyoFormSubmit(e);
      }
      if (type === 'open' || type === 'embedOpen') {
        var fid = detail.formId || '';
        if (fid === SIGNUP_FORM_ID) markSignupShown();
        if (fid === SAVE_FORM_ID) markSaveShown();
      }
    });
    window.addEventListener('klFormSubmit', onKlaviyoFormSubmit);
    document.addEventListener('klFormSubmit', onKlaviyoFormSubmit);
  }

  function boot() {
    if (pathBlocked()) return;
    if (sessionGet(SESSION_TEASER_DISMISS) === '1') teaserDismissed = true;
    bindKlaviyoSubmitListeners();

    refreshIdentified(function () {
      refreshCartCount(function (n) {
        if (n < 1 && !klaviyoIdentified) scheduleSignupCapture();

        document.addEventListener('mouseout', function (e) {
          var related = e.relatedTarget || e.toElement;
          if (related) return;
          onExitIntent(e);
        });

        document.addEventListener('visibilitychange', onVisibilityLeave);

        document.addEventListener('cart:updated', onCartChange);
        document.addEventListener('theme:cart:change', onCartChange);
        document.addEventListener('ajaxProduct:added', onCartChange);
        document.addEventListener('product:added', onCartChange);

        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.subscribe === 'function') {
          try {
            Shopify.analytics.subscribe('product_added_to_cart', onCartChange);
          } catch (err) {
            /* ignore */
          }
        }

        new MutationObserver(function () {
          hideSignupFlyout();
        }).observe(document.documentElement, { childList: true, subtree: true });

        // Re-check identity (cart email / identify mid-session) without blocking Save Cart
        setInterval(function () {
          refreshIdentified(function (identified) {
            if (identified) {
              cancelSignupTimer();
              cancelTeaserTimer();
              hideThemeTeaser();
            }
          });
          if (!saveShown && !saveSuppressed()) refreshCartCount();
        }, 15000);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
